export function formatActivationDate(value?: string | null): string {
  if (!value) return "Not recorded";
  const date = new Date(value.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(value) ? value : `${value}Z`);
  return Number.isNaN(date.getTime()) ? "Not recorded" : date.toLocaleString();
}

export const lastActiveHelp = "Last recorded contact with the licensing server. Offline use is not recorded.";
